export const UpcomingPromotion = "UPCOMING";
export const ActivePromotion = "ACTIVE";
export const PendingPromotion = "PENDING";